<script setup lang="ts">
/**
 * A spinner that decides between silent decoration and a live status region —
 * the one behaviour this app took from `@axon/ui`'s `Spinner` (ADR-0247).
 *
 * Give it a `label` and it becomes `role="status"` with that name, so a screen
 * reader says what is loading; omit it and it is `aria-hidden`, because a
 * spinner inside a busy button is already described by the button.
 */
import { computed } from 'vue';

const props = defineProps<{
  readonly size?: 'sm' | 'md' | undefined;
  /** Provide it and the spinner becomes a live status region; omit it and it is silent. */
  readonly label?: string | undefined;
}>();

const announced = computed(() => props.label !== undefined && props.label !== '');
</script>

<template>
  <span
    :class="['ow-spinner', size === 'sm' ? 'ow-spinner--sm' : 'ow-spinner--md']"
    :role="announced ? 'status' : undefined"
    :aria-label="announced ? label : undefined"
    :aria-hidden="announced ? undefined : true"
  />
</template>
